module.exports = { baseApiUrl: 'https://api.mdsibuyback.com/prod', environment: 'prod' };
